import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { addBugUsingPost } from "@/request/api/bugController";
import message from "@arco-design/web-vue/es/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'BugTrigger',
  setup(__props) {

const bugVisible = ref(false);
const content = ref();
const handleOk = async () => {
  bugVisible.value = false;
  const response = await addBugUsingPost({
    content: content.value,
  });
  if (response.data.code === 0) {
    message.success("反馈成功");
    content.value = "";
  } else {
    message.error("反馈失败，" + response.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_IconBug = _resolveComponent("IconBug")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_icon_info_circle_fill = _resolveComponent("icon-info-circle-fill")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_affix, {
      offsetBottom: 100,
      style: {"margin-left":"98%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          shape: "circle",
          size: "large",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (bugVisible.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconBug)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: bugVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((bugVisible).value = $event)),
      onOk: handleOk
    }, {
      title: _withCtx(() => [
        _createTextVNode("BUG反馈")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_typography_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_icon_info_circle_fill),
            _createTextVNode(" 在哪个页面，进行了什么操作，出现了什么问题 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_textarea, {
          modelValue: content.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((content).value = $event)),
          placeholder: "反馈BUG",
          autoSize: { minRows: 3 },
          style: {"margin-top":"10px"}
        }, {
          label: _withCtx(() => [
            _createTextVNode("BUG描述")
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})